import { withTranslation } from '@application/i18n/with_translation';
import { Flex, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Title } from '@component/title.component';

export function ViewNonRecoverableError() {
	return (
		<Flex
			fluid='vertical'
			grow='1'
			align='center'
			justify='center'
			gap={tokens.spacing.x1}
			style={{
				marginTop: tokens.size.x9,
			}}
		>
			<Title title={withTranslation('View.NonRecoverableError.Heading')} />
			<Text variant='bodyRegular' style={{ textAlign: 'center' }}>
				{withTranslation('View.NonRecoverableError.Text')}
			</Text>
		</Flex>
	);
}
